import { useConfigStore } from '@/stores';
import type { EventListItem } from '@/types/event';
import { findEventCustomContentByEvtDispNo, mapCustomContentToEventDetail } from '@/utils/event';
import { useMemo } from 'react';

export function useEventDetailData(event: EventListItem | null) {
    const language = useConfigStore((state) => state.config.ui.language);
    const buildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);

    return useMemo(() => {
        if (!event) return null;
        const customContent = findEventCustomContentByEvtDispNo(event.id, buildingMenus, language);
        return customContent ? mapCustomContentToEventDetail(customContent) : null;
    }, [event, buildingMenus, language]);
}
